import { BaseModel } from "../BaseModel";
import { BaseFindResult } from "../BaseFindResult";
import { BookingModel } from "./BookingModel";

export class BookingFindResultModel extends BaseFindResult {

    public getDataItem(i: number): BookingModel {
        let o: BookingModel = Object.assign(new BookingModel(), this.data[i]);
        return o;
    }

    public get dataTyped(): BookingModel[] {

        let d: BookingModel[] = [];

        for (var i = 0; i < this.data.length; i++) {
            d.push(this.getDataItem(i));
        }
        return d;
    }

    public override assignObjects(): void {
        super.assignObjects();

        for (var i = 0; i < this.data.length; i++) {
            let o: BookingModel = Object.assign(new BookingModel(), this.data[i]);
            this.data[i] = o;
        }
    }

}
